import styled from 'styled-components';

interface IProps {
    padding?: boolean;
}

export const Container = styled.div<IProps>`
    max-width: 1100px;
    margin: 0 auto;
    padding: ${({ padding }) => padding && '0 20px'};
`;
